import { useEffect, useRef, useState } from 'react';
import { useAtom } from 'jotai/index';
import { Toast } from 'primereact/toast';
import { toastAtom } from '~/atoms/toastAtom';
import {
  endpointLinkedDocumentsGET,
  LinkedDocument,
} from '~/api/def/endpoints/document/documentLinkedDocumentsEndpoint';
import { AgGridReact } from 'ag-grid-react';
import { colTypesWidths } from '~/components/ui/tables/ag/columnTypes';
import { agTheme } from '~/components/ui/tables/ag/agTheme';
import * as React from 'react';
import { colDefsLinkedDocumentsTable } from '~/components/ui/tables/ag/linkedDocuments/colDefsLinkedDocumentsTable';
export type LinkedDocumentsTableProps = {
  documentId?: string;
};
export const LinkedDocumentsTable = ({
  documentId,
}: LinkedDocumentsTableProps) => {
  const [toastCurrent] = useAtom<Toast | null>(toastAtom);
  const [documents, setDocuments] = useState<LinkedDocument[]>([]);
  const gridRef = useRef<AgGridReact<LinkedDocument>>(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (!documentId) {
      return;
    }
    const fetchLinkedDocuments = async () => {
      setIsLoading(true);
      const documentResponse = await endpointLinkedDocumentsGET(documentId);
      if (documentResponse?.success === 1) {
        setDocuments(documentResponse.data);
        setIsLoading(false);
      } else {
        if (toastCurrent) {
          toastCurrent.show({
            severity: 'error',
            summary: 'Fetching Linked Documents failed',
            detail: documentResponse?.message || 'Unknown status',
          });
        }
        setIsLoading(false);
      }
    };
    fetchLinkedDocuments();
  }, [documentId, toastCurrent]);

  return (
    <div style={{ height: '100%', marginLeft: '1rem' }}>
      {/*<h3>Linked Documents Table {documentId}</h3>*/}
      <AgGridReact
        rowData={documents}
        ref={gridRef}
        loading={isLoading}
        // getMainMenuItems={getMainMenuItems}

        // getContextMenuItems={ctxDocumentsContextMenu}
        columnDefs={colDefsLinkedDocumentsTable}
        columnTypes={colTypesWidths}
        tooltipShowDelay={0}
        theme={agTheme}
        suppressCellFocus
        onGridSizeChanged={() => gridRef.current?.api.sizeColumnsToFit()}
        autoSizeStrategy={{
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        }}
      />
    </div>
  );
};
